module.exports = __webpack_public_path__ + "img/bg2.b3010b0d.png";